module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("CHAPTER TWO")])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("D"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("AMIEN")])])])]), _vm._v(" W"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("YNTER")])]), _vm._v("…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Charlotte shot mental bolts of rejection at the man emerging from the limousine, straightening up beside her brother, actually topping Peter’s formidable height by an inch or two. He looked even more striking in a formal black dinner suit and she had no doubt that every woman at this party would be eyeing him over tonight. Which was fine, as long as he focussed on them and not on her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("From her position on the top deck of her father’s yacht she watched the two men stride down the dock, chatting amiably with one another. It was a further irritation that Peter liked "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("him")])]), _vm._v(" so much and hadn’t made any effort to become friendly with Mark. Was she going to lose both her father and her brother by going ahead with this marriage?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But I have my own life to live, came the sharp, anguished cry in her mind. Being a daughter, a sister, wasn’t enough. She wanted a partner who was happy to share his life with her and until she’d met Mark, she’d despaired of ever finding one. It wasn’t easy for her. Only Mark had made it easy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Except she didn’t feel at ease about anything now.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ah! The last arrivals!” Mark commented with satisfaction, noting where her attention had strayed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Charlotte turned her gaze back to her fiancé. They’d been on board for a while, watching other guests coming onto the yacht, which would very shortly cruise to the centre of Sydney Harbour and take up a prime position for viewing the New Year’s Eve fireworks. This was the first time Mark had been invited to join the Ramsey family on the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Sea Lion")])]), _vm._v(", and he was obviously eager to enjoy the experience.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“They’re not late,” she said, glancing at the new Cartier watch her parents had given her for Christmas. “Right on time, in fact. Eight o’clock. Peter knows Dad won’t wait a minute longer.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Fearsome man, your father,” Mark wryly remarked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She forced a smile, wanting to lessen any anxiety he might be nursing over her father’s attitude towards him. “Don’t worry about Dad. We’re going to have a brilliant night and I love having you here to share it with me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He smiled back, his face lighting up with the warm, impish charm that had first drawn her to him. Mark was not in the mould of traditional macho male, though he was certainly masculine enough when it came to making love, and he did match her well above average height, making them a perfect physical fit.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His thick, wavy brown hair invited touch, unlike the short back and sides style her father favoured. His twinkling hazel eyes invited fun, rather than pinning her to the spot in forceful challenge. His arched eyebrows were used to waggle with wicked mischief. She’d never seen them lowered in a disapproving or impatient frown. His nose was sharply ridged and his chin was narrow and chiselled, but his mouth was soft, his smile was soft, and usually its warmth made her feel safe with him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Safe in a nice, cosy sense.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She would never feel safe with Damien Wynter.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m the luckiest man here,” Mark murmured. “I’ve got the most beautiful woman with me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She laughed, happy that he thought so. The compliment made all the hours of effort worthwhile; having blonde and copper streaks put through her long, brown hair, finding and buying a stunning dress, taking the utmost care with her make-up. She wasn’t beautiful. She simply worked hard at putting herself together as best she could, using all the tricks the modelling school had taught her, highlighting her good points and minimising the not so good.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m surprised your brother doesn’t have a woman in tow tonight,” Mark said, raising one eyebrow quizzically. “No romance in the air for him on New Year’s Eve?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“More likely he didn’t want to give the time to it,” she said with dry irony. “Dad will have his usual poker game running in the bottom saloon in between the fireworks displays. No doubt Peter will be introducing his new friend from London to it. Nothing beats the adrenaline rush of a high-rolling game.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’ve played?” Mark asked curiously.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She shrugged. “Since I was a kid, but only at home. It was the one game our father played with us. He enjoyed teaching us the percentages.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mark shook his head in bemusement. “Strange childhood you had, Charlotte.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I want to make it different for our children, Mark,” she said earnestly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And so we will, my love.” He curved his arm around her shoulders, giving her a comforting hug of assurance as he softly blew the same words in her ear. “So we will.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She leaned into him, wanting her inner turmoil soothed by the loving way he treated her, the easy physical closeness he invited so naturally. The Ramseys were not openly demonstrative in their affection though the family had always been a tightly knit unit, made so from being set apart from the ordinary stream of people by great wealth.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Charlotte had tried to reach out across that barrier many times, only to be rebuffed by hurtful comments like, “It’s all right for you. You’re a Ramsey”—meaning she could have anything she wanted or get away with doing whatever she pleased. Which wasn’t true, but it was how she was perceived by others and nothing she said had ever changed their minds.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mark was the only man who had looked beyond the face value of her family and cared about the person she was inside, the needs she’d secretly nursed that all the money in the world could not fulfil. Perhaps it was because he wasn’t of her world and was curious about it, interested into probing more deeply than the surface. Whatever the reason, so much personal interest had made him very attractive, excitingly different to the many smugly arrogant heirs to fortunes who usually peopled her social circle.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But to her intense discomfort, she found herself wishing he excited her more sexually. Until this afternoon she hadn’t realised a man could affect her as Damien Wynter had. But that was probably an initial impact thing. She shouldn’t let it worry her. Mark was a very caring lover who was always concerned about giving her pleasure.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The powerful engines of the yacht thrummed with purpose. “Now that everyone’s on board, let’s stroll around to the front deck,” she suggested. “Set ourselves up for the best view of the fireworks.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They met and greeted other guests along the way, stopped to chat, had their glasses refilled with champagne, sampled some of the gourmet finger food being circulated by the waiters hired for the night. The party atmosphere lightened Charlotte’s private angst. She enjoyed Mark’s quick wit and easy manner. He was good company, always had been for her, always would be, she thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It shouldn’t matter—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("didn’t")])]), _vm._v(" matter—that her father and brother would always prefer the company of men like Damien Wynter. She didn’t want her life to be like her mother’s, filling in her time with charity functions while her husband wheeled and dealed in his own arena. She felt sorry for the woman Peter married, whomever she might be, doomed to always stand in second place to his business life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mark wanted her to be his professional assistant, helping to organise the events he arranged. They would share "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("everything")])]), _vm._v(". This coming new year should be marvellous, she thought, the best ever.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Even the fireworks tonight had been advertised as something extra special. The harbour foreshores were crowded with people, waiting to see them. The "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Sea Lion")])]), _vm._v(" was surrounded by all sorts of pleasure crafts, loaded with New Year’s Eve revellers. As nine o’clock approached—the time for the first fireworks display for families—Mark shepherded her through the melee of guests to the railing, intent on ensuring a clear view of the spectacular show.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“There you are!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her brother’s voice claimed her attention. She turned to find herself confronted by both Peter and the man whose company she definitely didn’t want. His dark eyes instantly engaged hers with a riveting intensity that stirred a determined rebellion. No way would she be sucked in by his alpha animal attraction a second time, not for a minute. He was "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("one of them")])]), _vm._v(", so arrogantly confident in his natural domination, undoubtedly expecting a woman to be his possession, not a real partner.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Damien, you’ve met my sister, Charlotte, in passing, so to speak. This is her fiancé, Mark Freedman.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The introduction was completed by the man himself. “Damien Wynter.” He barely flicked a glance of acknowledgement to Mark, concentrating his sexy charisma on her as he offered his hand again. “I hope we can further our acquaintance tonight, Charlotte,” he rolled out, pouring on the charm, flashing a smile designed to dazzle.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It raised her hackles to such a bristling height, it took every skerrick of her will-power to keep them sheathed and present a civil demeanour. She forced out her hand to take the one he’d offered, constructed a coolly polite smile, and said, “Well, Sydney is about to put on its best face for you, but I doubt you’ll get much out of me, Damien.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I beg your pardon?” He frowned over the rebuff as though he’d never had the experience of being knocked back by a woman.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She raised her eyebrows. “Isn’t that your aim in making a connection? How much you can get out of the person? Peter did tell me…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her brother laughed. “Charlotte is referring to how you replied to that stupid toast Tom Benedict made to me at the London club last year, declaring I was amongst friends, when in fact, most of them were strangers to me, and the only common ground we had was wealthy fathers.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Damien shook his head over the reminder. “Tom Benedict doesn’t have a brain in his head.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Perhaps he only meant to be kind,” Charlotte suggested. “And being kind does not necessarily rule out a brain.” She paused a moment to punctuate her point. “Quite possibly it’s simply one that works differently to yours.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As Mark’s did.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Which was one of the reasons why she preferred him to Damien Wynter, despite the obvious assets of the man who thought he could just muscle in and capture her interest.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Damien’s mind instantly registered a hit. His gaze narrowed on the brown eyes that remained flat, denying him any entry into what she was thinking. Why was he suddenly getting this flow of antagonism from Charlotte Ramsey? There’d been no trace of it in their brief meeting this afternoon. But that had been a surprise encounter. She’d had time to think about him since then—possibly as a threat she was intent on dispelling?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Did Peter paint me as cruel?” he asked, cutting straight to the point she seemed to be making.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Not at all.” She gave a tinkling laugh to remove any offence he might have taken. “He liked your honesty.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But you don’t?” he queried, putting her on the spot.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She didn’t miss a beat. “On the contrary, it’s always infinitely preferable to know what one is dealing with.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And what do you imagine you’re dealing with, Charlotte?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her eyebrows lifted in mock chiding. “I don’t imagine anything, Damien. As it was quoted to me, in reply to Tom Benedict’s toast, you said Peter was not your friend because you’d never met him before, and you were only interested in meeting him because of who he was, what he had and how much you might be able to get out of him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Damien smiled at the recollection. “In short, I cut through Tom’s hypocritical bullshit.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Winning my trust and my friendship,” Peter tossed in.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Which is happily mutual,” Damien good-humouredly affirmed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Like minds finding each other is always good,” Charlotte said with a suspiciously silky thread of approval. “I know how lucky I am to have met Mark.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She hooked her arm around her fiancé’s, subtly but emphatically placing herself at "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("his")])]), _vm._v(" side, having cleverly established that Damien and Peter formed a completely separate unit on a different planet to the one she wanted to inhabit with Mark Freedman.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Damien obligingly turned his attention to the man Peter had described as a smarmy fortune-hunter who had his sister sand-bagged from seeing any sense at all. But she was no fool. Far from it. She had a mind as sharp as knives. So Damien concentrated on taking his own measure of Charlotte Ramsey’s choice of partner.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sorry, Mark.” He smiled apologetically as he offered his hand. “I didn’t mean to ignore you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No problem,” came the easy assurance. “I was interested in hearing the background to your friendship with Peter.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His handshake had a touch of deference, aiming to please, not make it a contest of male egos. His eyes sparkled with appreciative interest, wanting to engage, "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("wanting to be part of the world Charlotte seemed intent on turning her back on,")])]), _vm._v(" Damien thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“In fact, it made me reflect on whether all our close associations with people are linked to how much we get out of them,” Mark commented whimsically. “We don’t tend to hang around those who give us nothing, do we?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It was a disarming little speech, opening up what could have been used as an attack on his integrity where his relationship with an heiress was concerned, then turning the picture around by making the principle a general one.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“We avoid boring people,” he went on, “and naturally gravitate to those who make our lives more interesting and pleasurable.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He smiled at Charlotte, giving her the sense that she was at the centre of these last sentiments, and Damien felt a surprisingly strong urge to kick him. The man was a master of manipulation, a first-rate charmer, and the smile now lighting up the face that had refused him any positive personal response twisted something in Damien’s gut.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He stared at her—this woman who was stirring feelings in him that demanded action to change the status quo. Was it because she was Peter’s sister and he empathised with his friend’s dislike of her being taken in by a user? Was it because she wouldn’t give him what she was readily giving to her fiancé?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He had met many more beautiful women, yet her smile for Mark Freedman illumined her own unique attraction, making it immeasurably stronger. The graceful turn of her long bare neck struck his eye. Her throat was bare of jewellery and its nakedness somehow evoked a vulnerability that stirred some very primitive instincts. The aggressive hunter and the protector leapt to battle readiness inside him and Damien knew he wouldn’t step back from involving himself with Charlotte Ramsey.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His gaze skated down the dress she had chosen for tonight. It was bright orange—a colour not many women could wear successfully, a colour that reinforced his initial impression that she was confident about herself.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Challengingly confident.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The style was a simple sheath attached to a beaded yoke. Very elegant. Again not overtly sexy yet all the more alluring because it subtly skimmed her curves instead of flaunting them in his face. Damien decided she was a woman who cared more about being seen as a person rather than a sexual object.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Had Mark Freedman played that card to win her?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Countdown to the fireworks is starting,” Peter said, waving Damien to join him at the deck railing as other guests automatically moved to make space for them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Millions of voices around the harbour rose in the chant, “Ten, nine, eight…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Charlotte broke apart from her fiancé to swing around and face the famous coat-hanger bridge that would obviously form the centrepiece of the display. Mark Freedman turned, as well, sliding his arm around her waist to hold her close. Damien stepped up between Peter and Charlotte, determined on making her aware of him whether she liked it or not.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“…three, two, one…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The great arch of the bridge was brilliantly outlined as white fireworks sprayed up from the entire span.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The start of something big, Damien thought, the excitement of this first explosive burst fuelling anticipation for what was to come. It reflected precisely how he was feeling about Charlotte Ramsey. One way or another he would take her from Mark Freedman, free her of a bad mistake.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Free her for himself.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-498c6f68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/billionairesscandalousmarriagethe_ch02.vue
// module id = 66
// module chunks = 0